import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import SimpleTooltipText from '../SimpleTooltipText';
import s from './SimpleTooltipContent.scss';
var SimpleTooltipContent = React.forwardRef(function (_a, ref) {
    var prefix = _a.prefix, postfix = _a.postfix, children = _a.children, className = _a.className, rest = __rest(_a, ["prefix", "postfix", "children", "className"]);
    return (React.createElement("div", __assign({ className: c(s['root'], className), ref: ref }, rest),
        prefix && React.createElement("div", { className: s['prefix'] }, prefix),
        React.createElement(SimpleTooltipText, { className: s['text'] }, children),
        postfix && React.createElement("div", { className: s['postfix'] }, postfix)));
});
SimpleTooltipContent.displayName = 'SimpleTooltipContent';
export default SimpleTooltipContent;
//# sourceMappingURL=SimpleTooltipContent.js.map